import * as yup from 'yup';

export const importantInfoSchema = yup.object().shape({
	importantInfo: yup.string(),
});
